import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
} from "react";
import _ from "lodash";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import SignaturePad from "signature_pad";

// import jsPDF from "jspdf";
import moment from "moment-timezone";
import $, { event } from "jquery";

// import { PDFDocument, } from 'pdf-lib';
import AgentAdded from "../../Components/img/Thankyou_page_Image.jpg";
import axios from "axios";

import user_service from "../service/user_service";
import http from "../service/http_common";
import Loader from "../../Pages/Loader/Loader.js";
import Toaster from "../../Pages/Toaster/Toaster.js";
import { useNavigate, useParams, NavLink } from "react-router-dom";

/**
 * Vendor advertising plans — Payment step only. `value` is stored as `adType` and must match backend pricing.
 * `months` is stored as `vendorAdPackageMonths` for approval term and expiration.
 */
const AD_PLAN_CARDS = [
  {
    value: "VendorAd6",
    months: 6,
    title: "Vendor Ad (6 months)",
    priceLine: "$300.00 — just $50.00 per month",
    description: "Six-month vendor advertising on the platform.",
  },
  {
    value: "VendorAd12",
    months: 12,
    title: "Vendor Ad (12 months)",
    priceLine: "$500.00 — just $41.66 per month",
    description: "Twelve-month vendor advertising on the platform.",
  },
];

const VENDOR_AGREEMENT_SECTIONS = [
  {
    title: "1. Platform and Services",
    paragraphs: [
      "BrokerAgentBase.com is a proprietary, cloud-based real estate brokerage software platform owned and operated by In Depth Realty in the State of Utah.",
      "The platform is utilized by licensed real estate agents affiliated with In Depth Realty for CRM and lead generation, transaction management and document coordination, back office operations, accounting and compliance, marketing and client communication, and general business operations.",
      "The platform includes a vendor advertising marketplace for third-party service providers to promote services to platform users, including agents, buyers, and sellers.",
      "Approved vendor advertisements are displayed within the Vendor section and organized by service categories such as Cleaning, Moving, Contractors, and related services.",
      "Company grants Vendor a limited, revocable, non-exclusive, non-transferable license to display advertising content on the platform during the applicable term.",
    ],
  },
  {
    title: "2. Eligibility and Authority",
    bullets: [
      "Vendor has full legal authority to enter into this Agreement.",
      "Vendor operates a legitimate business in compliance with all applicable laws.",
      "Any individual accepting this Agreement has authority to bind the Vendor entity.",
    ],
  },
  {
    title: "3. Advertising Submission and Approval",
    bullets: [
      "All advertisements are subject to prior review and written or electronic approval by Company.",
      "Company may approve or reject any advertisement, require modification or removal, and reclassify or recategorize advertisements in its sole discretion.",
      "Company is under no obligation to provide a reason for rejection.",
      "Submission does not guarantee acceptance or placement.",
    ],
  },
  {
    title: "4. Term; Commencement; Expiration",
    bullets: [
      "The advertising term commences upon Company approval of the advertisement.",
      "The term continues for the duration of the purchased package.",
      "Time is not prorated for delays caused by Vendor.",
      "Failure to utilize the full term does not entitle Vendor to extension or refund.",
    ],
  },
  {
    title: "5. Renewal; Auto-Expiration",
    bullets: [
      "Company will issue renewal notices approximately 30 days, 14 days, and 3 days prior to expiration.",
      "Vendor is solely responsible for maintaining accurate contact information and monitoring expiration dates.",
      "If Vendor fails to renew before expiration, the advertisement automatically terminates and related content may be removed permanently without further notice.",
      "Company has no obligation to retain, recover, or restore expired content.",
    ],
  },
  {
    title: "6. Fees; Payment; No Refunds",
    bullets: [
      "All fees are due in advance of publication.",
      "Payments are final and non-refundable once an advertisement is approved.",
      "No refunds are issued for early termination by Vendor, lack of performance, leads, or engagement, or removal/suspension due to breach.",
    ],
  },
  {
    title: "7. Account Access and Security",
    bullets: [
      "Vendor receives dashboard access upon approval.",
      "Vendor must maintain confidentiality of login credentials and is responsible for all activity under its account.",
      "Vendor must promptly notify Company of unauthorized access.",
      "Company is not liable for losses resulting from unauthorized account use.",
    ],
  },
  {
    title: "8. Content; Representations; Compliance",
    bullets: [
      "Vendor content must be accurate, lawful, non-misleading, and compliant with applicable laws.",
      "Vendor must own or secure all required rights, licenses, and permissions.",
      "Vendor content must not infringe third-party rights.",
      "Prohibited content includes false/deceptive claims, infringing materials, defamatory, obscene, or unlawful content.",
    ],
  },
  {
    title: "9. Indemnification",
    paragraphs: [
      "Vendor shall indemnify, defend, and hold harmless BrokerAgentBase.com, In Depth Realty, and their owners, officers, agents, employees, and affiliates from all claims, losses, damages, liabilities, costs, and expenses, including reasonable attorneys' fees, arising from Vendor advertisements or services, Vendor breach, or violations of law or third-party rights.",
    ],
  },
  {
    title: "10. Disclaimer of Warranties",
    bullets: [
      "Platform and services are provided on an 'as is' and 'as available' basis.",
      "Company disclaims all express and implied warranties including merchantability, fitness for a particular purpose, and non-infringement.",
      "Company does not warrant uninterrupted or error-free operation or guaranteed leads, revenue, or business opportunities.",
    ],
  },
  {
    title: "11. Limitation of Liability",
    bullets: [
      "Company is not liable for indirect, incidental, consequential, or punitive damages.",
      "Company's total aggregate liability shall not exceed total fees paid by Vendor within the preceding twelve (12) months.",
    ],
  },
  {
    title: "12. Termination; Suspension",
    bullets: [
      "Company may suspend or terminate Vendor access or remove advertisements at any time, with or without notice, for breach, non-compliance, or unlawful/fraudulent/unethical conduct.",
    ],
  },
  {
    title: "13. Intellectual Property",
    bullets: [
      "Vendor retains ownership of its content.",
      "Vendor grants Company a worldwide, royalty-free license to use, display, reproduce, and distribute content solely to provide services.",
    ],
  },
  {
    title: "14. Modifications",
    bullets: [
      "Company may modify this Agreement at any time.",
      "Updated terms are effective upon posting; continued use constitutes acceptance.",
    ],
  },
  {
    title: "15. Governing Law; Venue",
    bullets: [
      "This Agreement is governed by laws of the State of Utah.",
      "Any disputes shall be resolved exclusively in state or federal courts located within Utah.",
    ],
  },
  {
    title: "16. Severability",
    bullets: [
      "If any provision is invalid or unenforceable, remaining provisions remain in full force and effect.",
    ],
  },
  {
    title: "17. Entire Agreement",
    bullets: [
      "This Agreement constitutes the entire agreement and supersedes all prior agreements, representations, or understandings.",
    ],
  },
];

const VendorOnboarding = () => {
  const params = useParams();
  const [acceptedFileTypes, setAcceptedFileTypes] = useState([]);
  const navigate = useNavigate();
  const [formValuesNew, setFormValuesNew] = useState("");
  const [show, setIsShow] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [formErrorsVendor, setFormErrorsVendor] = useState({});
  const [isSubmitClickVendor, setISSubmitClickVendor] = useState(false);

  const [isSubmitClick, setISSubmitClick] = useState(false);
  const [loader, setLoader] = useState({ isActive: null });
  const [isSubmitClickNew, setISSubmitClickNew] = useState(false);

  const { isActive } = loader;
  const [toaster, setToaster] = useState({
    type: null,
    isShow: null,
    toasterBody: "",
    message: "",
  });
  const { type, isShow, toasterBody, message } = toaster;
  const [category, setCategory] = useState("");
  const [step1, setStep1] = useState(true);
  /** Step 2: product / company information */
  /** Step 3: advertising / payment plan selection */
  const [stepPayment, setStepPayment] = useState(false);
  /** Step 4: signature */
  const [stepSignature, setStepSignature] = useState(false);
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [flowComplete, setFlowComplete] = useState(false);

  const initialValues = {
    firstName: "",
    nickName: "",
    middleName: "",
    middleInitials: "",
    prefix: "",
    lastName: "",
    maidenName: "",
    suffix: "",
    email: "",
    passwordHash: "",
    confirmPassword: "",
  };

  const [accountData, setAccountData] = useState(initialValues);

  const initialValuesVendor = {
    office: "",
    productname: "",
    productblurb: "",
    description: "",
    linkurl: "",
    email: "",
    contactName: "",
    phone: "",
    product_fullDetails: "",
    companyName: "",
    adType: "",
  };

  const initialImage = {
    image: [],
  };
  const [formValues, setFormValues] = useState(initialValuesVendor);
  const [imageData, setImageData] = useState(initialImage);

  /** Clear session before paint so Header mount effects and jwt() in render never see a removed token. */
  useLayoutEffect(() => {
    if (localStorage.getItem("auth")) {
      localStorage.removeItem("auth");
      localStorage.removeItem("active_office");
      localStorage.removeItem("active_office_id");
    }
  }, [params.id]);

  useEffect(() => {
    window.scrollTo(0, 0);
    ContactGetByuniqueid();
  }, [params.id]);

  const ContactGetByuniqueid = async () => {
    await user_service.contactGetById(params.id).then((response) => {
      if (response && response.data) {
        if (response.data.passwordHash) {
          setStep1(false);
          setCategory(true);
        }
        setAccountData(response.data || {});
      }
    });
  };

  useEffect(() => {
    if (accountData && isSubmitClick) {
      validate();
    }
  }, [accountData, isSubmitClick]);

  const validate = () => {
    const values = accountData;
    const errors = {};

    if (values.passwordHash) {
      if (values.passwordHash.length < 8 || values.passwordHash.length > 30) {
        errors.passwordHash =
          "Password length must be between 8 and 30 characters.";
      }

      // Check for strong password criteria
      const strongPasswordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!strongPasswordRegex.test(values.passwordHash)) {
        errors.passwordHash =
          "Password must contain at least one lowercase letter, one uppercase letter, one digit, and one special character.";
      }
    } else {
      errors.passwordHash = "passwordHash is required";
    }

    if (values.confirmPassword !== values.passwordHash) {
      errors.confirmPassword = "Confirm password must match the password.";
    }

    if (values.confirmPassword) {
      if (
        values.confirmPassword.length < 8 ||
        values.confirmPassword.length > 30
      ) {
        errors.confirmPassword =
          "ConfirmPassword length must be between 8 and 30 characters.";
      }
    } else {
      errors.confirmPassword = "ConfirmPassword is required";
    }

    setFormErrors(errors);
    return errors;
  };

  const handleSubmit = async (e) => {
    if (params.id) {
      e.preventDefault();
      setISSubmitClick(true);
      let checkValue = validate();

      if (_.isEmpty(checkValue)) {
        const userData = {
          firstName: accountData.firstName,
          lastName: accountData.lastName,
          passwordHash: accountData.passwordHash,
        };

        setLoader({ isActive: true });
        const response = await user_service.contactUpdate(params.id, userData);

        if (response && response.data) {
          setCategory(true);
          setStep1(false);
          setLoader({ isActive: false });

          setToaster({
            type: "success",
            isShow: true,
            // toasterBody: response.data.message,
            message: "Password Setup Successfully.",
          });
          setTimeout(() => {
            setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
          }, 2000);
        } else {
          setLoader({ isActive: false });
          setToaster({
            type: "error",
            isShow: true,
            toasterBody: "Error",
            message: "Something Went Wrong.",
          });
        }
      }
    }
  };


  const [passwordShownn, setPasswordShownn] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordd = () => {
    setPasswordShownn(passwordShownn ? false : true);
  };
  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const [products, setProducts] = useState([]); // To hold the filtered vendor data

  const PromotoProductsGet = async (officeName) => {
    if (!officeName) {
      setLoader({ isActive: false });
      return;
    }
    try {
      const response = await user_service.PromotoProductsGet(officeName);

      if (response) {
        const vendorData = response.data.data.filter(
          (item) => String(item.category || "").toLowerCase() === "vendor"
        );
        setProducts(vendorData);
      }

      setLoader({ isActive: false });
    } catch (error) {
      console.error("Error fetching vendor data:", error);
      setLoader({ isActive: false });
    }
  };

  useEffect(() => {
    const office = accountData?.active_office;
    if (!office) return;
    setLoader({ isActive: true });
    PromotoProductsGet(office);
  }, [accountData?.active_office]);

  const [selectedVendor, setSelectedVendor] = useState({
    _id: "",
    description: "",
  });

  // Handle the dropdown change
  // const handleSelectChange = (e) => {
  //   const selectedOption = JSON.parse(e.target.value);
  //   setSelectedVendor(selectedOption);
  // };

  const handleSelectChange = (e) => {
    const selectedVendorId = e.target.value;
    const vendor = products.find((vendor) => vendor._id === selectedVendorId);

    // Store the selected vendor object
    setSelectedVendor(vendor || {});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccountData({ ...accountData, [name]: value });
  };

  const handleChangevendor = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    $("input[name='phone']").keyup(function () {
      $(this).val(
        $(this)
          .val()
          .replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3")
      );
      const formattedNumber = value.replace(
        /^(\d{3})(\d{3})(\d+)$/,
        "$1-$2-$3"
      );
      setFormValues({ ...formValues, ["phone"]: formattedNumber });
    });
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        },
      };

      try {
        const uploadResponse = await axios.post(
          "https://staging-api.brokeragentbase.com/upload",
          // "http://localhost:4000/upload",
          formData,
          config
        );

        const uploadedFileURL = uploadResponse.data;
        setImageData((prevImageData) => ({
          ...prevImageData,
          image: [
            ...(prevImageData.image || []), // Ensure previous images (if any) are kept
            {
              images: uploadedFileURL, // Add the new image URL
            },
          ],
        }));
      } catch (error) {
        console.error("Error occurred during file upload:", error);
      }
    }
  };

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleChangesVendor = (editorState) => {
    setEditorState(editorState);
    const htmlContent = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setFormValues({ ...formValues, product_fullDetails: htmlContent });
  };

  useEffect(() => {
    if (formValues && isSubmitClickVendor) {
      validateVendorInfo();
    }
  }, [formValues]);

  /** Step 2 (Information): product fields only — ad plan is chosen on the Payment step. */
  const validateVendorInfo = () => {
    const values = formValues;
    const errors = {};

    if (!selectedVendor.description) {
      errors.category = "Product is required.";
    }

    if (!values.productname) {
      errors.productname = "Product Name is required.";
    } else if (values.productname.length > 100) {
      errors.productname = "Product Name must be 100 characters or less.";
    }

    if (values.productblurb && values.productblurb.length > 50) {
      errors.productblurb = "Product blurb must be 50 characters or less.";
    }
    if (values.description && values.description.length > 500) {
      errors.description = "Description must be 500 characters or less.";
    }

    setFormErrorsVendor(errors);
    return errors;
  };

  /** Final submit: includes advertising plan from Payment step. */
  const validateVendorFull = () => {
    const errors = { ...validateVendorInfo() };
    if (!formValues.adType) {
      errors.adType = "Please select an advertising plan on the Payment step.";
    }
    setFormErrorsVendor(errors);
    return errors;
  };

  const handleSelectAdPlan = (value) => {
    setFormValues((prev) => ({ ...prev, adType: value }));
    setFormErrorsVendor((prev) => ({ ...prev, adType: undefined }));
  };

  const buildVendorProductPayload = () => {
    const plan = AD_PLAN_CARDS.find((p) => p.value === formValues.adType);
    const pkgMonths = plan?.months ?? 6;
    return {
      agentId: params.id,
      sponsorAgentId: accountData.agentId
        ? String(accountData.agentId)
        : undefined,
      vendorContactId: params.id,
      office_id: accountData.active_office_id,
      office_name: accountData.active_office,
      category: selectedVendor.description,
      category_id: selectedVendor._id,
      productname: formValues.productname,
      productblurb: formValues.productblurb,
      description: formValues.description,
      linkurl: formValues.linkurl,
      email: formValues.email,
      contactName: formValues.contactName,
      phone: formValues.phone,
      companyName: formValues.companyName,
      product_fullDetails: formValues.product_fullDetails,
      image: imageData.image,
      adType: formValues.adType,
      is_active: "0",
      vendorAdStatus: "pending",
      vendorAdPackageMonths: pkgMonths,
      vendorAdPaymentStatus: "pending",
      vendorAdApprovalRequestedAt: new Date().toISOString(),
    };
  };

  /** Step 2 → step 3: validate product info only */
  const handleContinueFromInfo = (e) => {
    e.preventDefault();
    setISSubmitClickVendor(true);
    const checkValue = validateVendorInfo();
    if (_.isEmpty(checkValue)) {
      setCategory(false);
      setStepPayment(true);
    }
  };

  /** Step 3 → step 4: advertising plan (cards) only */
  const handleContinueFromPayment = (e) => {
    e.preventDefault();
    if (!formValues.adType) {
      setFormErrorsVendor((prev) => ({
        ...prev,
        adType: "Please select one of the advertising plans.",
      }));
      setToaster({
        type: "error",
        isShow: true,
        message: "Please select an advertising plan.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    setStepPayment(false);
    setStepSignature(true);
  };

  // step3 function
  const [signaturePad, setSignaturePad] = useState(null);
  let signatureRedoArray = [];

  const readyPad = () => {
    const wrapper = document.getElementById("signature-pad");
    if (!wrapper) {
      console.error("Signature pad wrapper not found!");
      return;
    }

    const canvas = wrapper.querySelector("canvas");
    if (!canvas) {
      console.error("Canvas element not found!");
      return;
    }

    const context = canvas.getContext("2d");
    if (!context) {
      console.error("Could not get the 2D context for canvas!");
      return;
    }

    const w = Math.max(wrapper.clientWidth || 600, 280);
    const h = 200;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = w * ratio;
    canvas.height = h * ratio;
    canvas.style.width = `${w}px`;
    canvas.style.height = `${h}px`;
    context.scale(ratio, ratio);

    const tempSignaturePad = new SignaturePad(canvas, {
      backgroundColor: "rgb(255, 255, 255)",
    });

    setSignaturePad(tempSignaturePad);
  };

  function dataURLToBlob(dataURL) {
    const parts = dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }

  const handleUndo = () => {
    if (!signaturePad) return;
    let signatureRemovedData = [];
    let signatureData = signaturePad.toData();
    let signatureRedoData = _.cloneDeep(signatureData); //original data

    if (signatureData.length > 0) {
      signatureData.pop(); // remove the last dot or line
      signaturePad.fromData(signatureData);
      signatureRemovedData = signatureRedoData[signatureRedoData.length - 1];
      signatureRedoArray.push(signatureRemovedData);
    }
  };

  //   const handleRedo = () => {
  //     if (signatureRedoArray.length !== 0) {
  //       let values = signaturePad.toData();
  //       let lastValue = signatureRedoArray[signatureRedoArray.length - 1];
  //       values.push(lastValue);
  //       signaturePad.fromData(values);
  //       signatureRedoArray.pop(lastValue); //remove the redo item from array
  //     }
  //   };

  const handleClear = () => {
    if (signaturePad) signaturePad.clear();
  };

  useEffect(() => {
    if (!stepSignature) return undefined;
    window.scrollTo(0, 0);
    const id = setTimeout(() => readyPad(), 150);
    return () => clearTimeout(id);
  }, [stepSignature]);

  /** Final submit after signature (step 4) */
  const handleCompleteOnboarding = async (e) => {
    e.preventDefault();
    setISSubmitClickVendor(true);
    const checkValue = validateVendorFull();
    if (!_.isEmpty(checkValue)) {
      setToaster({
        type: "error",
        isShow: true,
        message:
          "Please complete all required fields (steps 2–3) or go back to fix them.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    if (!agreementAccepted) {
      setToaster({
        type: "error",
        isShow: true,
        message:
          "Please review and accept the Vendor Advertising Agreement before continuing.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    if (!signaturePad || signaturePad.isEmpty()) {
      setToaster({
        type: "error",
        isShow: true,
        message: "Please sign in the box below to confirm your agreement.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
      return;
    }
    const dataURL = signaturePad.toDataURL();
    const signatureBlob = dataURLToBlob(dataURL);
    const formData = new FormData();
    formData.append("file", signatureBlob, "vendor-signature.png");
    try {
      setLoader({ isActive: true });
      /** Use fetch so multipart boundary is set correctly; axios default JSON Content-Type breaks multer (req.file undefined → .location crash). */
      const base = String(http.defaults.baseURL || "").replace(/\/$/, "");
      const uploadRes = await fetch(`${base}/upload`, {
        method: "POST",
        body: formData,
      });
      if (!uploadRes.ok) {
        let errMsg = uploadRes.statusText;
        try {
          const errBody = await uploadRes.json();
          errMsg = errBody.message || errMsg;
        } catch {
          errMsg = (await uploadRes.text()) || errMsg;
        }
        throw new Error(errMsg);
      }
      const uploadedUrl = await uploadRes.text();
      const userData = buildVendorProductPayload();
      // Create the pending ad first, then send vendor to payment.
      const response = await user_service.addProductItems(userData);
      if (response) {
        await user_service.contactUpdate(params.id, {
          onboardfinal: "done",
          onboard_signature: uploadedUrl,
        });
        const createdItemId = response?.data?._id || response?.data?.data?._id;
        if (!createdItemId) {
          throw new Error("Vendor ad created but id was not returned");
        }

        const successUrl = `${window.location.origin}/signin?vendor=1&paid=1`;
        const cancelUrl = `${window.location.origin}/signin?vendor=1&paid=0`;
        const payResp = await user_service.vendorAdsPaymentCreateSession(
          createdItemId,
          successUrl,
          cancelUrl
        );

        const payUrl = payResp?.data?.url;
        if (payUrl) {
          window.location.href = payUrl;
          return;
        }

        setLoader({ isActive: false });
        setToaster({
          type: "success",
          isShow: true,
          message:
            "Vendor profile created. Payment session could not be started—please contact support.",
        });
      }
    } catch (error) {
      console.error("Error occurred while completing vendor onboarding:", error);
      setLoader({ isActive: false });
      setToaster({
        type: "error",
        isShow: true,
        message:
          error.response?.data?.message ||
          error.message ||
          "Could not save vendor profile.",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 3000);
    }
  };

  return (
    <div className="bg-secondary float-left w-100 pt-4 mb-4">
      <Loader isActive={isActive} />
      {isShow && (
        <Toaster
          type={type}
          isShow={isShow}
          toasterBody={toasterBody}
          message={message}
        />
      )}
      <div className="container onboarding">
        <main className="page-wrapper homepage_layout getContact_page_wrap">
          <div className="onboardingbutton">
            <div className="">
              {flowComplete ||
              (accountData.onboardfinal === "done" &&
                String(accountData.contactType || "").toLowerCase() ===
                  "vendor") ? (
                <div className="thank_you row align-items-center mt-md-2">
                  <div className="col-lg-7 order-lg-2 mb-lg-0 mb-4 pb-2 pb-lg-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5">
                    <img
                      className="d-block mx-auto"
                      src={AgentAdded}
                      alt="Hero image"
                    />
                  </div>
                  <div className="col-lg-5 order-lg-1 pe-lg-0">
                    <h1 className="display-5 mb-4 me-lg-n5 text-lg-start text-center mb-4">
                      Thank you
                    </h1>
                    <p className="text-lg-start text-center mb-4 mb-lg-5 fs-lg">
                      Vendor profile created successfully. Awaiting admin
                      approval.
                    </p>
                    <p className="text-lg-start text-center mb-4 mb-lg-5 fs-lg">
                      You can sign in later to manage your listing once it is
                      approved.
                    </p>
                    <div className="pull-right mt-2">
                      <NavLink
                        type="button"
                        className="btn btn-primary btn-sm"
                        to="/signin?vendor=1"
                      >
                        Go to login
                      </NavLink>
                    </div>
                  </div>
                </div>
              ) : accountData.onboardfinal === "done" ? (
                <div className="thank_you row align-items-center mt-md-2">
                  <div className="col-lg-7 order-lg-2 mb-lg-0 mb-4 pb-2 pb-lg-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5">
                    <img
                      className="d-block mx-auto"
                      src={AgentAdded}
                      alt="Hero image"
                    />
                  </div>
                  <div className="col-lg-5 order-lg-1 pe-lg-0">
                    <h1 className="display-5 mb-4 me-lg-n5 text-lg-start text-center mb-4">
                      Thank you
                    </h1>
                    <p className="text-lg-start text-center mb-4 mb-lg-5 fs-lg">
                      We are pleased to inform you that your account setup is
                      already done. Our team at Indepth Realty will review your
                      application, and upon approval, you will be notified via
                      email.
                    </p>
                    <div className="pull-right mt-2">
                      <NavLink
                        type="button"
                        className="btn btn-primary btn-sm"
                        to="/"
                      >
                        Go To Homepage
                      </NavLink>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <h3 className="">Welcome Onboard</h3>
                  <p>
                    Welcome to our vendor marketing platform! We’ve made it
                    simple for you to showcase your business and services
                    directly to our agents, who can help bring new opportunities
                    your way. Whether you're just starting to advertise or
                    already well-established, we’re here to make reaching your
                    goals easier. To get started, please provide the following
                    basic info about your business:
                  </p>
                  {/* <hr className="mb-3" /> */}
                  <div className="bg-light rounded-3 p-3 mb-3">
                    <div className="steps pt-4 pb-1">
                      <div className={step1 ? "step active" : ""}>
                        <div className="step-progress">
                          <span className="step-progress-start"></span>
                          <span className="step-progress-end"></span>
                          <span className="step-number">1</span>
                        </div>
                        <div className="step-label">Password</div>
                      </div>
                      <div
                        className={
                          category && !stepPayment && !stepSignature
                            ? "step active"
                            : ""
                        }
                      >
                        <div className="step-progress">
                          <span className="step-progress-start"></span>
                          <span className="step-progress-end"></span>
                          <span className="step-number">2</span>
                        </div>
                        <div className="step-label">Information</div>
                      </div>
                      <div className={stepPayment ? "step active" : ""}>
                        <div className="step-progress">
                          <span className="step-progress-start"></span>
                          <span className="step-progress-end"></span>
                          <span className="step-number">3</span>
                        </div>
                        <div className="step-label">Payment</div>
                      </div>
                      <div className={stepSignature ? "step active" : ""}>
                        <div className="step-progress">
                          <span className="step-progress-start"></span>
                          <span className="step-progress-end"></span>
                          <span className="step-number">4</span>
                        </div>
                        <div className="step-label">Acknowledgment & Signature</div>
                      </div>
                    </div>
                  </div>

                  {step1 ? (
                    <>
                      <div className="bg-light rounded-3 p-3 mb-3">
                        {/* <h2 className="h4 mb-4">
                        <i className="fi-info-circle text-primary fs-5 mt-n1 me-2"></i>
                        Basic info
                      </h2> */}
                        <div className="row">
                          <div className="col-sm-6 mb-2">
                            <label className="form-label" for="pr-fn">
                              First name
                            </label>
                            <input
                              className="form-control form-control-lg"
                              id="inline-form-input"
                              type="text"
                              name="firstName"
                              value={accountData.firstName}
                              onChange={handleChange}
                            />
                            {formErrors.firstName && (
                              <div className="invalid-tooltip">
                                {formErrors.firstName}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-6 mb-2">
                            <label className="form-label" for="pr-sn">
                              Last Name
                            </label>
                            <input
                              className="form-control form-control-lg"
                              id="inline-form-input"
                              type="text"
                              name="lastName"
                              value={accountData.lastName}
                              onChange={handleChange}
                            />
                            {formErrors.lastName && (
                              <div className="invalid-tooltip">
                                {formErrors.lastName}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-6 mb-2">
                            <label className="form-label" for="pr-phone">
                              Password
                            </label>
                            <span className="text-danger">*</span>
                            <div className="password-toggle">
                              <label
                                className="password-toggle-btn"
                                aria-label="Show/hide password"
                                onClick={togglePasswordd}
                              >
                                <span className="password-toggle-indicator"></span>
                              </label>
                            </div>
                            <input
                              className="form-control form-control-lg"
                              id="inline-form-input"
                              type={passwordShownn ? "text" : "password"}
                              placeholder="create a password"
                              name="passwordHash"
                              value={accountData.passwordHash}
                              onChange={handleChange}
                            />
                            {formErrors.passwordHash && (
                              <div className="invalid-tooltip">
                                {formErrors.passwordHash}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-6 mb-2">
                            <label className="form-label" for="pr-phone">
                              Confirm Password
                            </label>
                            <span className="text-danger">*</span>
                            <div className="password-toggle">
                              <label
                                className="password-toggle-btn"
                                aria-label="Show/hide password"
                                onClick={togglePassword}
                              >
                                <span className="password-toggle-indicator"></span>
                              </label>
                            </div>
                            <input
                              className="form-control form-control-lg"
                              id="inline-form-input"
                              type={passwordShown ? "text" : "password"}
                              name="confirmPassword"
                              placeholder="confirm password"
                              value={accountData.confirmPassword}
                              onChange={handleChange}
                            />
                            {formErrors.confirmPassword && (
                              <div className="invalid-tooltip">
                                {formErrors.confirmPassword}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="pull-right mt-3">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={handleSubmit}
                        >
                          Next step
                          <i className="fi-chevron-right fs-sm ms-2"></i>
                        </button>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {category ? (
                    <>
                      {/* <div className="bg-light rounded-3 p-3 mb-3">
                        <aside className="col-lg-12 col-md-5 pe-xl-4 mb-5">
                          <div className="multitab-action">
                            <div className="d-flex d-md-block d-lg-flex align-items-start pt-lg-2 mb-4">
                              <img
                                width="48"
                                height="48"
                                className="rounded-circle getContact_picture"
                                src={getContact?.image || Pic}
                                alt="getContact"
                              />
                              <div className="pt-md-2 pt-lg-0 ps-3 ps-md-0 ps-lg-3">
                                <h2 className="fs-lg mb-0">
                                  {getContact?.firstName} {getContact?.lastName}
                                </h2>
                                <ul className="list-unstyled fs-sm mt-2 mb-0 ps-0">
                                  {getContact?.phone ? (
                                    <>
                                      <li className="pb-0">
                                        <a
                                          className="nav-link fw-normal p-0"
                                          href={`tel:${
                                            getContact?.phone ?? ""
                                          }`}
                                        >
                                          <i className="fi-phone opacity-60 me-2"></i>
                                          {getContact?.phone}
                                        </a>
                                      </li>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  <li className="pb-2">
                                    <a
                                      className="nav-link fw-normal p-0"
                                      href={`mailto:${getContact?.email ?? ""}`}
                                    >
                                      <i className="fi-mail opacity-60 me-2"></i>
                                      {getContact?.email}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {agentId ? (
                              <div className="float-left text-center">
                                <label className="btn btn-primary documentlabel">
                                  <input
                                    id="REPC_real_estate_purchase_contract"
                                    type="file"
                                    accept={acceptedFileTypes
                                      .map((type) => `.${type}`)
                                      .join(",")}
                                    name="file"
                                    onChange={handleFileUpload}
                                    value={getContact.file}
                                  />
                                  <i className="fi-plus me-2"></i> Add a Photo
                                </label>
                                {formErrors.image && (
                                  <div
                                    className="invalid-tooltip"
                                    style={{
                                      backgroundColor: "#f6f3f800",
                                      float: "left",
                                    }}
                                  >
                                    {formErrors.image}
                                  </div>
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </aside>
                      </div> */}

                      <div className="col-md-12">
                        <div className="bg-light rounded-3 p-3  mb-3">
                          {/* <h2 className="h4 mb-4">
                            Contact
                          </h2> */}
                          <div className="row">
                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Name of Company
                                {/* <span className="text-danger">*</span> */}
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="companyName"
                                value={formValues.companyName}
                                onChange={handleChangevendor}
                              />
                              {formErrors.companyName && (
                                <div className="invalid-tooltip">
                                  {formErrors.companyName}
                                </div>
                              )}
                            </div>
                            <div className="col-sm-6 mb-2">
                              <label className="form-label" htmlFor="pr-sn">
                                Describe product or service
                              </label>

                              <select
                                className="form-select"
                                id="pr-city"
                                name="category"
                                value={selectedVendor._id || ""} // Ensure the selected _id is bound
                                onChange={handleSelectChange}
                              >
                                <option value="">--Select--</option>
                                {products.length > 0 ? (
                                  products.map((vendor, index) => (
                                    <option
                                      key={index}
                                      value={vendor._id} // Store only _id for simplicity
                                    >
                                      {vendor.title}
                                    </option>
                                  ))
                                ) : (
                                  <option>No vendors available</option>
                                )}
                              </select>

                              {formErrorsVendor?.category && (
                                <div className="invalid-tooltip">
                                  {formErrorsVendor.category}
                                </div>
                              )}
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label">
                                Product Name *
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="productname"
                                value={formValues.productname}
                                onChange={handleChangevendor}
                                style={{
                                  border: formErrorsVendor?.productname
                                    ? "1px solid red"
                                    : "1px solid #00000026",
                                }}
                              />
                              {formErrorsVendor.productname && (
                                <div className="invalid-tooltip">
                                  {formErrorsVendor.productname}
                                </div>
                              )}
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Product Blurb (Max Length: 50 characters)
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="productblurb"
                                value={formValues.productblurb}
                                onChange={handleChangevendor}
                              />
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Product Description (Max Length: 500 characters)
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="description"
                                value={formValues.description}
                                onChange={handleChangevendor}
                              />
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Website Link URL
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="linkurl"
                                value={formValues.linkurl}
                                onChange={handleChangevendor}
                              />
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Owner Name
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="contactName"
                                value={formValues.contactName}
                                onChange={handleChangevendor}
                              />
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Email
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="email"
                                value={formValues.email}
                                onChange={handleChangevendor}
                              />
                            </div>

                            <div className="col-sm-6 mb-2">
                              <label className="form-label" for="pr-fn">
                                Phone
                              </label>
                              <input
                                className="form-control form-control-lg"
                                id="inline-form-input"
                                type="text"
                                name="phone"
                                value={formValues.phone}
                                onChange={handleChangevendor}
                              />
                            </div>
                            <div className="col-sm-6 mb-2">
                              <div className="my-3 file-uploader pt-3">
                                <label className="form-label">
                                  Select a photo to upload:
                                </label>
                                <br />
                                <input
                                  id="fileUpload"
                                  type="file"
                                  name="image"
                                  onChange={handleFileChange}
                                  accept={acceptedFileTypes
                                    .map((type) => `.${type}`)
                                    .join(",")}
                                />
                              </div>

                              <div className="productItemImage">
                                {imageData.image.length > 0 && (
                                  <>
                                    {imageData.image.map(
                                      (uploadedImage, index) => (
                                        <>
                                          {uploadedImage ? (
                                            <div className="product_images">
                                              <img
                                                className="m-0 mb-3 shadow-sm"
                                                src={uploadedImage.images}
                                              />
                                              {/* <span className="delete_data">
                                    <img
                                      className="m-0"
                                      onClick={(e) =>
                                        handleRemove(uploadedImage.images)
                                      }
                                      src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                                    />
                                  </span> */}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      )
                                    )}
                                  </>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12 mt-3">
                              <label className="form-label">
                                Product Full Details
                              </label>
                              <Editor
                                editorState={editorState}
                                onEditorStateChange={handleChangesVendor}
                                value={formValues.product_fullDetails}
                                toolbar={{
                                  options: [
                                    "inline",
                                    "blockType",
                                    "fontSize",
                                    "list",
                                    "textAlign",
                                    "history",
                                    "link", // Add link option here
                                  ],
                                  inline: {
                                    options: [
                                      "bold",
                                      "italic",
                                      "underline",
                                      "strikethrough",
                                    ],
                                  },
                                  list: { options: ["unordered", "ordered"] },
                                  textAlign: {
                                    options: ["left", "center", "right"],
                                  },
                                  history: { options: ["undo", "redo"] },
                                  link: {
                                    // Configure link options
                                    options: ["link", "unlink"],
                                  },
                                }}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-3 mt-4 pt-3 border-top w-100">
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              setCategory(false);
                              setStep1(true);
                            }}
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm align-self-sm-end"
                            onClick={handleContinueFromInfo}
                          >
                            Next step
                            <i className="fi-chevron-right fs-sm ms-2"></i>
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {stepPayment ? (
                    <>
                      <div className="col-md-12">
                        <div className="bg-light rounded-3 p-3 mb-3">
                          <h4 className="h5 mb-2">Payment method</h4>
                          <p className="small text-muted mb-3">
                            Choose a 6- or 12-month vendor advertising term.
                            Card processing is coming soon — your choice is
                            saved for admin review and does not block
                            onboarding.
                          </p>

                          <label className="form-label fw-semibold">
                            Advertising plan
                          </label>
                          <div className="row g-3 mb-2">
                            {AD_PLAN_CARDS.map((plan) => {
                              const selected = formValues.adType === plan.value;
                              return (
                                <div key={plan.value} className="col-md-6">
                                  <div
                                    role="button"
                                    tabIndex={0}
                                    className={`h-100 rounded-3 border p-3 ${
                                      selected
                                        ? "border-primary border-2 shadow-sm bg-white"
                                        : "border bg-white"
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleSelectAdPlan(plan.value)
                                    }
                                    onKeyDown={(ev) => {
                                      if (ev.key === "Enter" || ev.key === " ") {
                                        ev.preventDefault();
                                        handleSelectAdPlan(plan.value);
                                      }
                                    }}
                                  >
                                    <div className="fw-bold text-primary mb-1">
                                      {plan.title}
                                    </div>
                                    <div className="small text-muted mb-2">
                                      {plan.priceLine}
                                    </div>
                                    <p className="small mb-0">{plan.description}</p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {formErrorsVendor.adType && (
                            <div className="text-danger small mb-0">
                              {formErrorsVendor.adType}
                            </div>
                          )}

                          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-3 mt-4 pt-3 border-top w-100">
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => {
                                setStepPayment(false);
                                setCategory(true);
                              }}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm align-self-sm-end"
                              onClick={handleContinueFromPayment}
                            >
                              Next step
                              <i className="fi-chevron-right fs-sm ms-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {stepSignature ? (
                    <>
                      <div className="col-md-12">
                        <div className="bg-light rounded-3 p-3 mb-3">
                          <h4 className="h5 mb-1">Acknowledgment & Signature</h4>
                          <p className="small text-muted mb-3">
                            Please review the agreement below. You must accept
                            the terms and provide a signature to complete vendor
                            onboarding.
                          </p>

                          <div className="bg-white border rounded-3 p-3 mb-3">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                              <div>
                                <h5 className="mb-1">
                                  Vendor Advertising Agreement and Terms of
                                  Service
                                </h5>
                                <div className="small text-muted">
                                  BrokerAgentBase.com
                                </div>
                              </div>
                              <span className="badge bg-info text-dark">
                                Effective Date:{" "}
                                {new Date().toLocaleDateString()}
                              </span>
                            </div>

                            <div
                              className="border rounded-3 p-3"
                              style={{
                                maxHeight: 340,
                                overflowY: "auto",
                                background: "#fcfcfe",
                              }}
                            >
                              <p className="small mb-3">
                                This Vendor Advertising Agreement and Terms of
                                Service ("Agreement") is a legally binding
                                agreement between BrokerAgentBase.com
                                ("Company"), used by In Depth Realty, a Utah
                                licensed real estate brokerage, and the vendor
                                ("Vendor"). By accessing the platform, creating
                                an account, purchasing advertising, or
                                submitting content, Vendor agrees to be bound by
                                this Agreement.
                              </p>

                              {VENDOR_AGREEMENT_SECTIONS.map((section) => (
                                <div key={section.title} className="mb-3">
                                  <h6 className="mb-2">{section.title}</h6>
                                  {section.paragraphs?.map((p) => (
                                    <p key={p} className="small mb-2">
                                      {p}
                                    </p>
                                  ))}
                                  {section.bullets?.length ? (
                                    <ul className="small mb-2 ps-3">
                                      {section.bullets.map((b) => (
                                        <li key={b} className="mb-1">
                                          {b}
                                        </li>
                                      ))}
                                    </ul>
                                  ) : null}
                                </div>
                              ))}
                            </div>

                            <div className="form-check mt-3">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="vendor-terms-accept"
                                checked={agreementAccepted}
                                onChange={(e) =>
                                  setAgreementAccepted(e.target.checked)
                                }
                              />
                              <label
                                className="form-check-label small"
                                htmlFor="vendor-terms-accept"
                              >
                                I have read, understood, and agree to the
                                Vendor Advertising Agreement and Terms of
                                Service. I confirm I have authority to bind my
                                business to these terms.
                              </label>
                            </div>
                          </div>

                          <h6 className="mb-2">Signature</h6>
                          <p className="small text-muted mb-2">
                            Use a touch screen or your mouse to sign below as
                            your electronic acceptance.
                          </p>
                          <div id="signature-pad" className="border rounded bg-white">
                            <canvas className="signature-canvas w-100" style={{ minHeight: 180 }} />
                          </div>
                          <div className="mt-2 mb-3">
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm me-2"
                              onClick={handleUndo}
                            >
                              <i className="fa fa-undo me-1" aria-hidden="true"></i>
                              Undo
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm"
                              onClick={handleClear}
                            >
                              <i className="fa fa-eraser me-1" aria-hidden="true"></i>
                              Clear
                            </button>
                          </div>
                          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-3 mt-4 pt-3 border-top w-100">
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => {
                                setStepSignature(false);
                                setStepPayment(true);
                              }}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm align-self-sm-end"
                              onClick={handleCompleteOnboarding}
                            >
                              Complete onboarding
                              <i className="fi-chevron-right fs-sm ms-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default VendorOnboarding;
